const gtmChangePasswordError = () => {
    dataLayer.push({
        event: 'forgot_password',
        step: 'reset_password_error',
        _clear: true,
    })
}

export default gtmChangePasswordError
